import PricingGrid from "./components/pricing/pricing-grid.vue";
import LizaPremiumGrid from "./components/pricing/liza-premium-grid.vue";
import SalesPricingTable from "./components/pricing/sales-pricing-table.vue";
import SalesPricingTableLiza from "./components/pricing/sales-pricing-table-liza.vue";
import GiantTooltip from "../../components/giant-tooltip.vue";
import CheckoutWizard from "./components/checkout/wizard.vue";
import Subscription from "./components/checkout/subscription.vue";
import CustomerDetails from "./components/checkout/customer-details.vue";
import Payment from "./components/checkout/payment.vue";
import {useStore} from "./store";
import {createVueInstance} from "../../vue-root";

createVueInstance({
    name: 'order-page',
    components: {
        PricingGrid,
        LizaPremiumGrid,
        SalesPricingTable,
        SalesPricingTableLiza,
        GiantTooltip,
        CheckoutWizard,
        Subscription,
        CustomerDetails,
        Payment
    },
    data() {
        return {
            checkoutStore: useStore()
        }
    }
});
